export class User {
    usuarioId: number;
    nombre: string;
    abreviacion: string;
    medicoId?: number;
    coordinador: string;
    email: string;
    telefono: string;
    verTodosMedicos?: boolean;
    verTodosCoordinadores?: boolean;
    gestor?: boolean;
    due?: boolean;
    grupoEmpresaId?: number;
    carteraEmpresas?: number;
}